import React from "react";

import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

import useStyles from "./RbScrollView.styles";

function RbScrollView(props) {
  const {
    children,
    className: classNameProp,
    classes: classesProp,
    ...other
  } = props;

  const classes = useStyles(props);

  const [shouldShadow, setShouldShadow] = React.useState(false);

  const handleScroll = React.useCallback((event) => {
    const { target } = event;
    setShouldShadow(target.scrollTop > 4);
  }, []);

  const rootClassName = `${classes.root} ${classNameProp || ""} ${
    shouldShadow ? classes.root_shadow : ""
  }`;

  return (
    <Box {...other} className={rootClassName} onScroll={handleScroll}>
      {children}
    </Box>
  );
}

RbScrollView.propTypes = {
  /** Class name */
  className: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.shape({
    root: PropTypes.object,
    root_shadow: PropTypes.object,
    inner: PropTypes.object,
  }),
};

RbScrollView.defaultProps = {
  className: undefined,
  children: null,
  classes: undefined,
};

export default React.memo(RbScrollView);
